import { useFetchInertiaPageJson } from '@shared/composables/useFetchInertiaPageJson.js';
import type { AxiosRequestConfig } from 'axios';
import type { ListResponse } from '@shared/types/ApiResponse';

export function useFetchListData<T>(url: string, component: string, transformUsing?: (data: T[]) => T[], partialData: string[] = [], config?: AxiosRequestConfig) {
    const processing = ref(true);
    const data: Ref<T[]> = ref([]);
    const error: Ref<unknown> = ref(null);

    useFetchInertiaPageJson<ListResponse<T>>(url, component, partialData, {
        ...config,
        ...{
            params: {
                limit: 0,
            },
        },
    })
        .then(({ data: page }) => {
            if (transformUsing) {
                data.value = transformUsing((page.props as ListResponse<T>).data);
            } else {
                data.value = (page.props as ListResponse<T>).data;
            }
        })
        .catch((err: unknown) => {
            error.value = err;
            console.error(err);
        })
        .finally(() => {
            processing.value = false;
        });

    return {
        data,
        processing,
        error,
    };
}
